/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Laps_Splits_OtherInputs */

const en_ui_laps_splits_other = /** @type {(inputs: Ui_Laps_Splits_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} splits`)
};

const de_ui_laps_splits_other = /** @type {(inputs: Ui_Laps_Splits_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Splits`)
};

/**
* | output |
* | --- |
* | "{count} splits" |
*
* @param {Ui_Laps_Splits_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_splits_other = /** @type {((inputs: Ui_Laps_Splits_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Splits_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_splits_other(inputs)
	return de_ui_laps_splits_other(inputs)
});